import React from "react"
import styles from "./styles.scss"
import SearchBarWrapper from "components/SearchBarWrapper"
import { selectCounty, getCounty } from "data/counties"
import { selectCategoryFromProps, getCategory } from "data/categories"
import { connect } from "react-redux"

class SearchBanner extends React.Component {
  componentDidMount() {
    const { getCategory, getCounty, categoryId, countyId } = this.props
    categoryId && getCategory(categoryId)
    countyId && getCounty(countyId)
  }

  componentDidUpdate(prevProps) {
    const { getCategory, getCounty, categoryId, countyId } = this.props
    if (
      prevProps.countyId === countyId ||
      prevProps.categoryId === categoryId
    )
      return null
    categoryId && getCategory(categoryId)
    countyId && getCounty(countyId)
  }

  render() {
    const { ammount, category, county, onSelectCounty } = this.props

    return (
      <div className={styles.container}>
        {category &&
          county && (
            <p className={styles.text}>
              Hittade <strong>{ammount}</strong> st träffar inom{" "}
              <strong>{category.name}</strong> i{" "}
              <strong>{county.name}</strong>{" "}
            </p>
          )}
        <div className={styles.searchbar}>
          <SearchBarWrapper onSelectCounty={onSelectCounty} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  county: selectCounty(state, ownProps),
  category: selectCategoryFromProps(state, ownProps),
})

export default connect(mapStateToProps, {
  getCategory,
  getCounty,
})(SearchBanner)



// WEBPACK FOOTER //
// src/components/SearchBanner/index.jsx